<template>
  <div>
    <NavBar/>
    <div class="container">
      <ChangePassword/>
    </div>
  </div>
</template>

<script>

import NavBar from '../components/NavBar.vue';
import ChangePassword from '../components/ChangePassword.vue';

export default {
  name: 'Configuracoes',
  components: {
    NavBar,
    ChangePassword
  }
}
</script>

<style scoped>

.container {
  display: flex;
  height: 100vh;
  background: linear-gradient(0deg, #3a67bf, #020094),
  linear-gradient(90deg, #3a67bf, #020094),
  linear-gradient(135deg, #3a67bf, #020094);
}

</style>